import React, { useState, useEffect } from "react";
import { X, Link as LinkIcon, ExternalLink, Trash2 } from "lucide-react";

export default function POUrlModal({
  isOpen,
  onClose,
  initialUrl = "",
  onSave,
  itemName = "",
  vendorName = ""
}) {
  const [url, setUrl] = useState(initialUrl);

  useEffect(() => {
    if (isOpen) {
      setUrl(initialUrl || "");
    }
  }, [isOpen, initialUrl]);

  if (!isOpen) return null;

  const getFormattedHref = (rawUrl) => {
    if (!rawUrl) return "#";
    if (rawUrl.startsWith("http://") || rawUrl.startsWith("https://")) {
      return rawUrl;
    }
    return `https://${rawUrl}`;
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (onSave) {
      onSave(url.trim());
    }
    onClose();
  };

  const handleClear = () => {
    setUrl("");
    if (onSave) {
      onSave("");
    }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{ width: "90%", maxWidth: "520px", padding: "1.5rem" }}
      >
        <div className="modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem", borderBottom: "1px solid var(--border-color)", paddingBottom: "0.75rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
            <div style={{ 
              width: "32px", 
              height: "32px", 
              borderRadius: "6px", 
              backgroundColor: "rgba(0, 180, 216, 0.15)", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center",
              color: "var(--primary)"
            }}>
              <LinkIcon size={18} />
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: "1.1rem" }}>Product Catalog URL</h3>
              {(itemName || vendorName) && (
                <div style={{ fontSize: "0.8rem", color: "var(--text-secondary)", marginTop: "0.15rem" }}>
                  {itemName ? <span>{itemName}</span> : null}
                  {itemName && vendorName ? " • " : null}
                  {vendorName ? <span style={{ color: "var(--primary)" }}>{vendorName}</span> : null}
                </div>
              )}
            </div>
          </div>
          <button className="modal-close" onClick={onClose} style={{ background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer" }}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSave}>
          <div style={{ marginBottom: "1.25rem" }}>
            <label className="form-label" style={{ display: "block", marginBottom: "0.5rem", fontSize: "0.85rem", color: "var(--text-secondary)" }}>
              Catalog / Product URL
            </label>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <input
                type="text"
                className="form-input"
                placeholder="https://vendor.com/product-catalog-link"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                autoFocus
                style={{ flex: 1 }}
              />
              {url.trim() && (
                <a
                  href={getFormattedHref(url.trim())}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary"
                  style={{ display: "inline-flex", alignItems: "center", gap: "0.3rem", padding: "0.5rem 0.75rem", fontSize: "0.85rem", textDecoration: "none" }}
                  title="Test link in new tab"
                >
                  <ExternalLink size={14} />
                  Open
                </a>
              )}
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid var(--border-color)", paddingTop: "1rem", marginTop: "1rem" }}>
            <div>
              {initialUrl ? (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClear}
                  style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem", color: "var(--danger)", borderColor: "rgba(231, 76, 60, 0.3)" }}
                >
                  <Trash2 size={14} />
                  Clear URL
                </button>
              ) : null}
            </div>
            <div style={{ display: "flex", gap: "0.75rem" }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                style={{ minWidth: "90px" }}
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
